/* eslint-disable react/no-unused-prop-types */
import {
  AnchorButton,
  Button,
  Intent,
  PopoverPosition,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { Unlink } from 'src/components/icons/Unlink';
import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';

export const enum EntityDrawerButtonType {
  ATTRIBUTE = 'ATTRIBUTE',
  RELATIONSHIP = 'RELATIONSHIP',
}

type EntityDrawerButtonProps = {
  disabled?: boolean;
  onClick: () => void;
  tooltip?: string;
  type: EntityDrawerButtonType;
};

export const AddButton: React.VFC<Omit<EntityDrawerButtonProps, 'type'>> = ({
  disabled,
  onClick,
  tooltip,
}) => (
  <Tooltip content={tooltip || ''} disabled={!tooltip}>
    <AnchorButton
      data-testid={TEST_IDS.projectDiagram.entityDrawer.addButton}
      disabled={disabled}
      intent={Intent.PRIMARY}
      onClick={onClick}
      outlined
      text={copy.components.projectDiagram.entityDrawerButtons.add}
    />
  </Tooltip>
);

export const EditButton: React.VFC<EntityDrawerButtonProps> = ({
  disabled,
  onClick,
  type,
}) => {
  let tooltipContent = copy.components.projectDiagram.entityDrawerButtons.edit;
  if (disabled) {
    if (type === EntityDrawerButtonType.ATTRIBUTE) {
      tooltipContent =
        copy.components.projectDiagram.entityDrawerButtons
          .attributeEditDisabled;
    } else if (type === EntityDrawerButtonType.RELATIONSHIP) {
      tooltipContent =
        copy.components.projectDiagram.entityDrawerButtons
          .relationshipEditDisabled;
    }
  }
  return (
    <Tooltip content={tooltipContent}>
      <Button
        className="sd-hidden-until-hover"
        data-testid={TEST_IDS.projectDiagram.entityDrawer.editButton}
        disabled={disabled}
        icon={IconNames.EDIT}
        minimal
        onClick={onClick}
      />
    </Tooltip>
  );
};

export const UnlinkButton: React.VFC<EntityDrawerButtonProps> = ({
  disabled,
  onClick,
  type,
}) => {
  let tooltipContent =
    copy.components.projectDiagram.entityDrawerButtons.unlink;
  if (disabled) {
    if (type === EntityDrawerButtonType.ATTRIBUTE) {
      tooltipContent =
        copy.components.projectDiagram.entityDrawerButtons
          .attributeUnlinkDisabled;
    } else if (type === EntityDrawerButtonType.RELATIONSHIP) {
      tooltipContent =
        copy.components.projectDiagram.entityDrawerButtons
          .relationshipUnlinkDisabled;
    }
  }
  return (
    <Tooltip
      content={tooltipContent}
      // auto is default, but left here for readability
      position={disabled ? PopoverPosition.BOTTOM_LEFT : PopoverPosition.AUTO}
    >
      <Button
        className="sd-hidden-until-hover"
        data-testid={TEST_IDS.projectDiagram.entityDrawer.unlinkButton}
        disabled={disabled}
        icon={<Unlink />}
        minimal
        onClick={onClick}
      />
    </Tooltip>
  );
};

export const UpdateButton: React.VFC<Omit<EntityDrawerButtonProps, 'type'>> = ({
  disabled,
  onClick,
  tooltip,
}) => (
  <Tooltip content={tooltip || ''} disabled={!tooltip}>
    <AnchorButton
      data-testid={TEST_IDS.projectDiagram.entityDrawer.updateButton}
      disabled={disabled}
      intent={Intent.PRIMARY}
      onClick={onClick}
      outlined
      text={copy.components.projectDiagram.entityDrawerButtons.update}
    />
  </Tooltip>
);
